export const chapter4Translations = {
  name: "Глава 4: Распятие и Воскресение",
  description: "Следуйте истории страданий, смерти и воскресения Иисуса",
  spiritualWisdom: "Крест - это символ окончательного триумфа любви и победы над грехом. Воскресение дает нам обещание новой жизни во Христе.",
  
  levels: {
    40: {
      name: "Арест",
      challenge: "Узнайте об аресте Иисуса в Гефсиманском саду",
      
      questions: {
        easy: {
          question: "В каком саду был арестован Иисус?",
          options: ["Гефсимания", "Эдем", "Оливковая", "Назарет"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "Какой знак использовал Иуда, чтобы предать Иисуса?",
          options: ["Рукопожатие", "Поцелуй", "Слово", "Жест"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Какой ученик отсек мечом ухо слуги первосвященника?",
          options: ["Иаков", "Иоанн", "Петр", "Андрей"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Гефсимания - это сад у подножия Елеонской горы",
        "Иуда предал Иисуса за 30 серебренников",
        "Иисус чудесным образом исцелил ухо слуги"
      ],
      
      funFacts: [
        "Гефсимания означает 'масличный пресс', где производилось оливковое масло",
        "Арест Иисуса произошел глубокой ночью",
        "Иисус пошел мирно, прося учеников не сопротивляться насилием"
      ]
    },

    41: {
      name: "Отречение Петра",
      challenge: "Узнайте, как Петр трижды отрекся от Иисуса",
      
      questions: {
        easy: {
          question: "Сколько раз Петр отрекся от Иисуса?",
          options: ["Один раз", "Два раза", "Три раза", "Четыре раза"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Что произошло после третьего отречения Петра?",
          options: ["Взошло солнце", "Запел петух", "Сверкнула молния", "Произошло землетрясение"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Где был Петр, когда отрекся от Иисуса?",
          options: ["В храме", "Во дворе первосвященника", "Во дворце Пилата", "В Гефсимании"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Иисус предсказал отречение Петра",
        "Петр горько заплакал, осознав, что сделал",
        "Всё произошло в ту же ночь"
      ],
      
      funFacts: [
        "Иисус сказал 'Прежде чем пропоет петух, трижды отречешься от Меня'",
        "Отречение Петра - мощный пример человеческой слабости и божественного прощения",
        "Петр позже стал великим лидером Церкви"
      ]
    },

    42: {
      name: "Иисус перед Пилатом",
      challenge: "Узнайте о суде над Иисусом перед римским наместником",
      
      questions: {
        easy: {
          question: "Кем был Пилат?",
          options: ["Учеником", "Римским наместником", "Первосвященником", "Фарисеем"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Чего не нашел Пилат в Иисусе?",
          options: ["Мудрости", "Вины", "Смелости", "Силы"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Что сделал Пилат, чтобы символизировать свою невиновность?",
          options: ["Умыл руки", "Разорвал одежду", "Постился", "Молился"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Пилат хотел освободить Иисуса",
        "Толпа требовала распятия Иисуса",
        "Пилат уступил политическому давлению"
      ],
      
      funFacts: [
        "Жена Пилата предупредила его не делать ничего против Иисуса",
        "Умывание рук было символом невиновности в иудейской традиции",
        "Решение Пилата показало провал человеческого правосудия"
      ]
    },

    43: {
      name: "Варавва или Иисус",
      challenge: "Узнайте о выборе толпы в пользу Вараввы",
      
      questions: {
        easy: {
          question: "Кем был Варавва?",
          options: ["Учеником", "Разбойником", "Священником", "Царем"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Что мог сделать Пилат во время иудейского праздника?",
          options: ["Освободить одного узника", "Простить налоги", "Устроить пир", "Закрыть храм"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Кого выбрала толпа?",
          options: ["Иисуса", "Варавву", "Обоих", "Никого"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Это был праздник Пасхи",
        "Толпа требовала распять Иисуса",
        "Варавва был убийцей и мятежником"
      ],
      
      funFacts: [
        "Имя Варавва означает 'сын отца'",
        "Освобождение Вараввы - символ жертвы Христа",
        "Мы все Варавва, освобожденные жертвой Иисуса"
      ]
    },

    44: {
      name: "Бичевание и Терновый Венец",
      challenge: "Узнайте о страданиях Иисуса",
      
      questions: {
        easy: {
          question: "Что солдаты возложили на голову Иисуса?",
          options: ["Золотую корону", "Терновый венец", "Венок из цветов", "Тюрбан"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Как солдаты издевались над Иисусом?",
          options: ["Называя его царем", "Побивая камнями", "Заключая в тюрьму", "Игнорируя его"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Что содержал римский бич?",
          options: ["Кожаные полосы", "Кусочки кости и металла", "Только дерево", "Веревку"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Бичевание было жестоким римским наказанием",
        "Солдаты одели Иисуса в багряницу",
        "Иисус молча перенес всё это"
      ],
      
      funFacts: [
        "Терновый венец символизирует проклятие греха",
        "Багряный цвет был царским цветом, использованным для насмешки",
        "Страдания Иисуса исполняют пророчества Исаии"
      ]
    },

    45: {
      name: "Путь на Голгофу",
      challenge: "Узнайте, как Иисус нес крест",
      
      questions: {
        easy: {
          question: "Что нес Иисус?",
          options: ["Флаг", "Крест", "Корону", "Меч"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Кто помог Иисусу нести крест?",
          options: ["Петр", "Иоанн", "Симон Киринеянин", "Иосиф"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "Что означает Голгофа?",
          options: ["Святая гора", "Место черепа", "Место мира", "Место правосудия"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Иисус падал от слабости",
        "Женщины плакали по пути",
        "Процессия прошла через город"
      ],
      
      funFacts: [
        "Крест весил около 40-50 кг",
        "Голгофа находилась за городскими стенами",
        "Симон Киринеянин пришел из Африки"
      ]
    },

    46: {
      name: "Распятие",
      challenge: "Узнайте о распятии Иисуса",
      
      questions: {
        easy: {
          question: "Со сколькими другими людьми был распят Иисус?",
          options: ["Ни с кем", "С одним", "С двумя", "С тремя"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Что сказал Иисус на кресте: 'Отче, ___ им'?",
          options: ["Спаси", "Прости", "Останови", "Накажи"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Какая была надпись на кресте?",
          options: ["Грешник", "Царь Иудейский", "Мятежник", "Пророк"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Иисус был распят в третьем часу дня",
        "Солдаты бросали жребий о его одеждах",
        "Иисус произнес семь слов с креста"
      ],
      
      funFacts: [
        "Надпись была написана на трех языках: еврейском, латинском и греческом",
        "Один из разбойников раскаялся в последний момент",
        "Иисус поручил свою мать заботе Иоанна"
      ]
    },

    47: {
      name: "Смерть Иисуса",
      challenge: "Узнайте о последних часах Иисуса",
      
      questions: {
        easy: {
          question: "Что произошло в момент смерти Иисуса?",
          options: ["Солнце засияло ярче", "Наступила тьма", "Пошел дождь", "Появилась радуга"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Что разорвалось в храме?",
          options: ["Пол", "Завеса", "Стена", "Потолок"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Какими были последние слова Иисуса?",
          options: ["Совершилось", "Жажду", "Отче, в руки Твои предаю дух Мой", "Зачем Ты Меня оставил"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Тьма длилась три часа",
        "Солдат пронзил копьем бок Иисуса",
        "Сотник сказал 'Истинно Человек Сей был Сын Божий'"
      ],
      
      funFacts: [
        "Завеса храма разорвалась сверху донизу, не рукой человека",
        "Это произошло во время Пасхи, когда приносился в жертву агнец",
        "Смерть Иисуса оплатила цену греха"
      ]
    },

    48: {
      name: "Погребение",
      challenge: "Узнайте о погребении Иисуса",
      
      questions: {
        easy: {
          question: "В чью гробницу был положен Иисус?",
          options: ["Петра", "Иосифа Аримафейского", "Никодима", "Лазаря"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Во что было обернуто тело Иисуса?",
          options: ["В багряницу", "В золотые одежды", "В белое полотно", "Без одежд"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "Что принес Никодим для тела Иисуса?",
          options: ["Масло", "Смирну и алой", "Воду", "Цветы"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Гробница была высечена в новой скале",
        "Большой камень привалили ко входу",
        "Стражи были поставлены охранять гробницу"
      ],
      
      funFacts: [
        "Это была гробница богатого человека, исполняя пророчество Исаии",
        "Погребение было совершено поспешно, так как приближалась суббота",
        "Иосиф был тайным учеником, который стал смелым"
      ]
    },

    49: {
      name: "Пустая Гробница",
      challenge: "Узнайте об открытии утра воскресения",
      
      questions: {
        easy: {
          question: "Кто первым нашел гробницу пустой?",
          options: ["Петр", "Иоанн", "Женщины", "Солдаты"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Где был камень?",
          options: ["Разбит", "Отвален", "Всё еще на месте", "Исчез"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Сколько ангелов встретили женщины в гробнице?",
          options: ["Ни одного", "Одного", "Двух", "Трех"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Это было утро первого дня недели",
        "Женщины пришли помазать тело Иисуса",
        "Ангелы возвестили благую весть"
      ],
      
      funFacts: [
        "Женщины были первыми свидетелями, что было революционной деталью",
        "Петр и Иоанн побежали к гробнице",
        "Одной пустой гробницы было недостаточно, Иисус должен был явиться"
      ]
    },

    50: {
      name: "Иисус является Марии Магдалине",
      challenge: "Узнайте о первом явлении Иисуса",
      
      questions: {
        easy: {
          question: "Кому первой явился Иисус после воскресения?",
          options: ["Петру", "Иоанну", "Марии Магдалине", "Фоме"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "За кого Мария сначала приняла Иисуса?",
          options: ["За ангела", "За садовника", "За солдата", "За фарисея"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Что сказал Иисус Марии, когда она узнала Его?",
          options: ["Иди и возвести", "Не прикасайся ко Мне", "Не бойся", "Веруй"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Мария плакала у гробницы",
        "Иисус позвал ее по имени",
        "Он послал ее возвестить братьям"
      ],
      
      funFacts: [
        "Иисус выбрал женщину для своего первого явления",
        "Мария стала первым апостолом",
        "Она назвала Его 'Раввуни' (Учитель)"
      ]
    },

    51: {
      name: "На дороге в Эммаус",
      challenge: "Узнайте о явлении Иисуса на дороге",
      
      questions: {
        easy: {
          question: "Сколько учеников шли в Эммаус?",
          options: ["Один", "Два", "Три", "Четыре"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Когда ученики узнали Иисуса?",
          options: ["Сразу", "При преломлении хлеба", "На дороге", "Никогда"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Что объяснял им Иисус по дороге?",
          options: ["Будущее", "Писания", "Закон", "Чудеса"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Иисус шел с ними как странник",
        "Их сердца горели, когда Он говорил",
        "Иисус исчез, когда они узнали Его"
      ],
      
      funFacts: [
        "Эммаус находился примерно в 11 км от Иерусалима",
        "Иисус показал им, как все Писания говорили о Нем",
        "Ученики сразу побежали обратно в Иерусалим"
      ]
    },

    52: {
      name: "Явление ученикам",
      challenge: "Узнайте о явлении Иисуса в закрытой комнате",
      
      questions: {
        easy: {
          question: "Где были ученики, когда явился Иисус?",
          options: ["В храме", "На рынке", "В закрытой комнате", "В Гефсимании"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Что показал Иисус ученикам?",
          options: ["Свои раны", "Свое лицо", "Свои одежды", "Свет"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Какого ученика не было в первый раз?",
          options: ["Петра", "Иоанна", "Фомы", "Иакова"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Двери были заперты из страха",
        "Иисус сказал 'Мир вам'",
        "Он дунул на них и сказал 'Примите Духа Святого'"
      ],
      
      funFacts: [
        "Иисус ел с ними, чтобы доказать, что Он не призрак",
        "Фома поверил неделю спустя",
        "Иисус являлся много раз в течение 40 дней"
      ]
    }
  }
};
